<div class="upper">
  @if (upper) {
    <ng-container *ngTemplateOutlet="upper"></ng-container>
  }
</div>

<div class="lower">
  @if (lower) {
    <ng-container *ngTemplateOutlet="lower"></ng-container>
  }
</div>

<app-page-spinner *ngIf="isLoading" [withPadding]="true"></app-page-spinner>
